module.exports = __webpack_public_path__ + "static/media/logo-conga.fcdaffb3.svg";